import styled from 'styled-components';

export const RadioInput = styled.input`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-left: 1.2rem;
  color: var(--color-contrast-brand);
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  margin-top: 3px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    border: 1.4px solid var(--color-neutral-500);
    border-radius: 50%;
    background-color: #fff;
    transition: all 0.2s ease;
  }

  &:after {
    content: '';
    position: absolute;
    left: .17rem;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--color-action-default);
    transition: all 0.2s ease;
    opacity: 0;
  }
`;

export const RadioContainer = styled.div`
  position: relative;
  margin: 8px 0;

  ${RadioInput}:checked + ${RadioLabel}:after {
    opacity: 1;
  }

  ${RadioInput}:disabled:checked + ${RadioLabel}:after {
    background-color: var(--color-brand-400);
  }
`;